module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-fall-in-love-svgrepo-com.f9b22bed.svg";